import type {
  DraftAgentRequest,
  DraftAgentResult,
} from '../server-only/ai/draft-agent';

/**
 * Project Bobcat — `POST /ai/agents/draft` (`server-only/ai/router.ts`): the
 * AI draft of one use-case agent, for a task Create found no template for.
 * Same-origin plain `fetch`, like `use-action-assist.ts`.
 */

/** A little under the server function's 60s limit, as the assistant does. */
const TIMEOUT_MS = 55_000;

export const requestAgentDraft = async (
  body: DraftAgentRequest
): Promise<DraftAgentResult> => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const response = await fetch('/ai/agents/draft', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    const json = await response.json().catch(() => null);
    if (!response.ok) {
      const b = json as { detail?: string; error?: string } | null;
      throw new Error(b?.detail ?? b?.error ?? response.statusText);
    }
    return json as DraftAgentResult;
  } finally {
    clearTimeout(timer);
  }
};
